import { render, staticRenderFns } from "./AddWeek.vue?vue&type=template&id=035c2f18"
import script from "./AddWeek.vue?vue&type=script&lang=js"
export * from "./AddWeek.vue?vue&type=script&lang=js"
import style0 from "./AddWeek.vue?vue&type=style&index=0&id=035c2f18&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports